import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    currentBusStopId: null,
    busStopSetId: 1, //1,2が塙、3が町田
    busStopList: [
      {
        id: "1",
        name: "厚生病院",
        latlon_lat: "36.959611123241466",
        latlon_lon: "140.40791255454795",
        titles: "厚生病院",
      },
    ],
    mobilityData: [],
    dayOfWeek: 0,
    dayOfWeekStr: "",
    hour: 0,
    minute: 0,
    mail: "",
    businessHoursStart: 9,
    businessHoursEnd: 16,
    holiday: ["日"],
    businessDayTxt: "月曜日～土曜日",
    driverMode: null,
    currentMobilityId: null,
    center_lat: 33.421098388409156,
    center_lon: 130.53217894685852,
    busLatLng_lat_1: 35.57577969333916,
    busLatLng_lon_1: 139.46405703490612,
    busHeading_1: 270,
    busSpeed_1: 0,
    passengers: 0,
    errorMSG: "",
    nowRequestingId: null,
    comingMobility: null,
    comingMobilities: [],
    comingRequests: [],
    inBreakMobilities: [],
    timeoutDialog: false,
    getMobilityDataTimerId: null,
    playGuideCall: false,
    outOfService: false,
    operationCommand: null,
    startUpTimestamp: null,
    callTimeout: 30000,
    ip: "",
    busStopToGo: [],
    home: [],
    homeLat: null,
    homeLon: null,
    crossLatlon: { lat: 33.41746670195899, lon: 130.53058875000002 },
    btmMsg: "",
    headerHeight: 0,
    reserve_at_timestamp: null,
    reservation: {
      id: null,
      location_name: null,
      destination_name: null,
      reserve_at: null,
    },
    requestingId: null,
    numbers: [],
    getCrewsInterval: 5000,
  },
  mutations: {},
  actions: {},
  modules: {},
});
